import React from "react";
import { CostIndexRanges } from "./const";
import { CostIndexValue } from "./CostIndexValue";
import { useTranslation } from "react-i18next";

export const CostIndexRuler = () => {
  const { t } = useTranslation();
  const values = CostIndexRanges.map((r) => r.index);
  return (
    <div className="cost-index-ruler">
      <div className="cost-index-ruler-title">
        {t("components.CostIndexRuler.costIndex")}
      </div>
      <div className="ruler">
        <span>
          {t("components.CostIndexRuler.lowestFormat", { value: values[0] })}
        </span>
        {values.map((v) => (
          <CostIndexValue value={v} key={v} />
        ))}
        <span>
          {t("components.CostIndexRuler.highestFormat", {
            value: values[values.length - 1],
          })}
        </span>
      </div>
    </div>
  );
};
